// extracted by mini-css-extract-plugin
module.exports = {"airdrop-detail-wrap":"activity_airdrop-detail-wrap__6u2Zr","spinWrap":"activity_spinWrap__sWa8L","bannerImg":"activity_bannerImg__8Hw7U"};